module.exports = __webpack_public_path__ + "img/base_activites_mode.31cbdd93.svg";